import React from 'react';
import { isEncodedCellValue } from '../../../../common/helpers/agGrid';
import PropTypes from 'prop-types';
import { agentsColumns } from '../../../../agent-production/constants/agentProductionConstants';
import { truncateLine } from '../../../helpers/pdf';
import { searchTerms } from '../../../../constants';

const Table = ({
    searchResults,
    tableView,
    config,
}) => {

    const totalRows = searchResults.length;
    const DEFAULT_ROWS_PER_TABLE = 25;
    const rowsPerTable = config.rowsPerTable ?? DEFAULT_ROWS_PER_TABLE;
    const numberOfTables = Math.ceil(totalRows / rowsPerTable);
    const MAX_OFFICE_NAME_LENGTH = 57;

    const TableSection = ({ searchResults, tableView, startIndex, endIndex }) => {
        const createTableRows = () => {
            return searchResults.slice(startIndex, endIndex).map((row, i) => {
                const isLastRow = i + startIndex === searchResults.length - 1;
                return (
                    <tr
                        key={`content-${startIndex + i}`}
                        className={config.hasTotalsRow && isLastRow ? 'totals-row' : ''}
                    >
                        {tableView.tables.map((table, index) => {
                            const value = row[table.col.keyField ?? table.col.id];
                            const isBoldTotalsLabel = config.hasBoldTotalsLabel && value === searchTerms.totals;
                            const displayValue = config.hasTruncation && table.col.id === agentsColumns.officeName.id
                                ? truncateLine(value, MAX_OFFICE_NAME_LENGTH)
                                : value;

                            return (
                                <td
                                    key={index}
                                    className={`${table.colDef.cellClass?.includes('td-num') ? 'right' : 'left'} ${isBoldTotalsLabel ? 'totals-row-title' : '' }`}
                                >
                                    {!isEncodedCellValue(value) && (table.colDef?.valueFormatter?.({ value: displayValue }) ?? displayValue)}
                                </td>
                            );
                        })}
                    </tr>
                );
            });
        };

        return (
            <div className={config.hasAgentDetailHeader ? 'agent-detail-page-section' : 'page-section' }>
                <table className={`table ${config.hasAgentDetailHeader ? 'agent-detail-table' : '' }`}>
                    <thead>
                        <tr>
                            {tableView.tables.map((table, index) => (
                                <th
                                    key={index}
                                    className={table.colDef?.headerClass?.includes('align-top') ? 'right' : 'left'}>
                                    {table.col.label || table.colDef.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {createTableRows()}
                    </tbody>
                </table>
            </div>
        );
    };

    const tableSections = Array.from({ length: numberOfTables }, (_, index) => {
        const startIndex = index * rowsPerTable;
        const endIndex = Math.min(startIndex + rowsPerTable, totalRows);

        return (
            <TableSection
                key={`table-section-${index}`}
                searchResults={searchResults}
                tableView={tableView}
                startIndex={startIndex}
                endIndex={endIndex}
            />
        );
    });

    return <div>{tableSections}</div>;
};

Table.propTypes = {
    searchResults: PropTypes.array,
    tableView: PropTypes.object,
    config: PropTypes.object,
};

export default Table;
